module.exports = __webpack_public_path__ + "./images/199120eef28ebb1b66ed47beef4cc9b2.png";